import { EXPLORE_ROUTES } from "../homeDashboard/exploreRoutes";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../dashboard/Dashboard.css";
import "../DashboardQuestionBank.css";
import "../homeDashboard/HomeDashboard.css";
import "../homeDashboard/DashboardSkeleton.css";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import TopicCard from "./TopicCard";
import { useQuestionBankSubTopics } from "../hooks/useQuestionBankSubTopics";
import {
  buildQuestionBankBackTarget,
  buildQuestionBankFlowState,
  getStoredQuestionBankFlowState,
  persistQuestionBankFlowState,
} from "./qbankFlowState";

const QuestionBank = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const storedFlowState = React.useMemo(() => getStoredQuestionBankFlowState(), []);
  const flowState = React.useMemo(
    () => buildQuestionBankFlowState(location.state, storedFlowState),
    [location.state, storedFlowState]
  );
  const subTopicRequestParams = flowState?.subTopicRequestParams || null;
  const selectedTopic = flowState?.selectedTopic || null;
  const [currentPage, setCurrentPage] = React.useState(Number(flowState?.subTopicRequestParams?.page || 1));
  const resolvedSubTopicRequestParams = React.useMemo(
    () => ({
      ...(subTopicRequestParams || {}),
      category_id: Number(subTopicRequestParams?.category_id || 2),
      page: currentPage,
    }),
    [currentPage, subTopicRequestParams]
  );
  const {
    data: subTopicData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuestionBankSubTopics(resolvedSubTopicRequestParams, {
    enabled: Boolean(
      resolvedSubTopicRequestParams?.subject_id &&
        resolvedSubTopicRequestParams?.topic_id !== undefined &&
        resolvedSubTopicRequestParams?.state_id
    ),
  });
  const isSubTopicPending = isLoading || isFetching;

  const subTopicScreenState = React.useMemo(
    () =>
      buildQuestionBankFlowState({
        ...flowState,
        subTopicRequestParams: resolvedSubTopicRequestParams,
        qbankBackTarget:
          flowState?.qbankBackTarget || buildQuestionBankBackTarget(EXPLORE_ROUTES.topics, flowState),
      }),
    [flowState, resolvedSubTopicRequestParams]
  );

  React.useEffect(() => {
    persistQuestionBankFlowState(subTopicScreenState);
  }, [subTopicScreenState]);

  React.useEffect(() => {
    if (!subTopicRequestParams) {
      navigate(EXPLORE_ROUTES.topics, { replace: true, state: flowState });
    }
  }, [flowState, navigate, subTopicRequestParams]);

  if (!subTopicRequestParams) {
    return null;
  }

  return (
    <>
      <style>
        {`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }
      .layout-wrapper.homeDashboard-wrapper {
         background: linear-gradient(to bottom, rgba(103, 78, 221, 0.05) 0%, #fff 100%)!important;
       }
        `}
      </style>

      <HomeDashboardLayout showHeader={false}>
        <section className="qb Qbank-TopicCard" aria-label="Question bank introduction">
          <div className="qb-body">
            <div className="d-flex align-items-center justify-content-center">
              <div className="qb-copy">

                <div className="qb-loc">
                  <i className="bi bi-geo-alt-fill" />
                  <span> {subTopicData?.stateName || "Himachal Pradesh"}</span>
                </div>

                <h1 className="qb-title">
                  <span>{subTopicData?.topicName || selectedTopic?.name || "Topic"}</span>
                </h1>

                <p className="qb-sub">{subTopicData?.subTopicLang || "Sub Topics"}</p>
              </div>
            </div>
          </div>
        </section>

        <div className="innerContent dashboardExam">
          {isError ? (
            <div className="cs-status">
              {error?.response?.data?.message || error?.message || "Unable to load sub topics."}
            </div>
          ) : (
            <TopicCard
              topics={subTopicData?.topicList || []}
              isLoading={isSubTopicPending}
              requestParams={resolvedSubTopicRequestParams}
              navigationState={subTopicScreenState}
              mode="subtopic"
              pagination={subTopicData?.pagination || {}}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              emptyMessage="No sub topics available."
            />
          )}
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default QuestionBank;
